<template>
  <div class="omk-list-items-container">
    <omk-list :id="id" full-width>
      <div v-for="(item, index) in items" :key="index">
        <omk-list-item>
          <div slot="headline">{{ item.physicalAddress }}</div>
          <!-- <div slot="supporting-text">{{ item.description }}</div> -->
          <!-- <omk-icon slot="end">arrow_forward</omk-icon> -->
        </omk-list-item>
        <omk-divider inset></omk-divider>
      </div>
    </omk-list>
  </div>
</template>

<script>
export default {
  name: "ListItems",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    hint: {
      type: String,
      default: "                                           ",
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    isDateField: {
      type: Boolean,
      default: false,
    },
    remainderOfEstateMargin: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleInput(event) {
      const value = event.target ? event.target.value : event;
      this.$emit("input", value);
    },
    handleClick(event) {
      this.$emit("click", event);
      if (this.isDateField) {
        this.$emit("date-picker-click", event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.omk-list-select-container {
  z-index: 0;

  .list-select {
    margin-bottom: 24px;
  }
}
</style>
